import moment from 'moment';
import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import checkTickIcon from '../../assets/images/check-tick-icon.svg';
import roundBellIcon from '../../assets/images/round-bell-icon.svg';
import SortIcon from '../../assets/images/sort-icon.svg';
import tickIcon from '../../assets/images/tick-icon.svg';
import Checkbox from '../../components/layouts/CheckBox';
import CustomModal from '../../components/layouts/CustomModal';
import PaymentLoader from '../../components/layouts/PaymentLoader';
import Button from '../../components/ui/Button';
import CustomRadioWithTooltip from '../../components/ui/CustomRadioWithTooltip';
import PageLayout from '../../components/ui/PageLayout';
import { Config } from '../../config/Config';
import { ApiConstants } from '../../constants/ApiConstants';
import { ApiTypes } from '../../constants/Constants';
import { Routes } from '../../constants/RouteConstants';
import authContext from '../../context/authContext';
import useMakeRequest from '../../utils/ApiHelper';
import CheckoutForm from './CheckoutForm';

const Subscription = () => {
    let profile: any = useContext(authContext);
    const navigate = useNavigate();
    const { state } = useLocation();
    const currentPlan = useMakeRequest();
    const cancelSubscription = useMakeRequest();
    const cancelFreeTrial = useMakeRequest();
    const subPlans = useMakeRequest();
    const checkout = useMakeRequest();
    const [selectedPlanName, setSelectedPlanName] = useState('')
    const [activePlanName, setActivePlanName] = useState('')
    const [selectedPlan, setSelectedPlan] = useState('')
    const [selectedPlanForSubscribe, setSelectedPlanForSubscribe] = useState('')
    const [plans, setPlans] = useState<Record<string, any>[]>([]);
    const [planType, setPlanType] = useState<'MONTHLY' | 'YEARLY'>('MONTHLY')
    const [stripeSessionSecret, setStripeSessionSecret]: any = useState(null);
    const [showPaymentLoader, setShowPaymentLoader] = useState(false);
    const [showContinueButton, setShowContinueButton] = useState(false)
    const [showTrialBox, setShowTrialBox] = useState(false);
    const [isSubscribed, setIsSubscribed] = useState(false);
    const [checkedSubTerm, setCheckedSubTerm] = useState(false);
    const [visibleCancelSubModal, setVisibleCancelSubModal] = useState(false);
    const [visibleCancelFreeTrialModal, setVisibleCancelFreeTrialModal] = useState(false);
    const [selectedPlanForFreeTrial, setSelectedPlanForFreeTrial] = useState('');

    const getCurrentPlan = async () => {
        await currentPlan.makeRequest({ url: ApiConstants?.CurrentPlan, type: ApiTypes?.GET })
    }

    useEffect(() => {
        subPlans.makeRequest({ url: ApiConstants?.SubscriptionGetPlans })
        getCurrentPlan()
    }, [])

    useEffect(() => {
        if (subPlans?.status) {
            let defaultType: 'MONTHLY' | 'YEARLY' = 'MONTHLY';
            const curPlanData = currentPlan?.data?.data;
            if (curPlanData && curPlanData?.status === 1 && curPlanData?.plan_detail?.plan_type) {
                defaultType = curPlanData.plan_detail.plan_type;
            }

            const plansArr: any[] = []
            subPlans?.data?.data?.length > 0 && subPlans?.data?.data?.forEach((p: any) => {
                if (p?.is_free || p?.plan_type === defaultType) {
                    const sortedPerms = p.plan_perms ? [...p.plan_perms].sort((a: any, b: any) => {
                        const orderA = a.permission?.sort_order ?? 100;
                        const orderB = b.permission?.sort_order ?? 100;
                        return orderA - orderB;
                    }) : [];
                    plansArr.push({ ...p, plan_perms: sortedPerms })
                }
            })
            const plusPlans =
                subPlans?.data?.data?.filter((p: any) => p?.title === 'Plus') || [];

            console.log("plusPlans: ", plusPlans)
            console.log("plansArr: ", plansArr)
            setSelectedPlanName(plusPlans[0]?.title)
            setSelectedPlanForFreeTrial(plusPlans[0]?.uuid)
            setPlans(plansArr)
            setPlanType(defaultType)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [subPlans?.status, currentPlan?.status])

    const handleChangePlanType = (checked: boolean) => {
        const pType = checked ? 'YEARLY' : 'MONTHLY'
        const plansArr: any[] = []
        subPlans?.data?.data?.length > 0 && subPlans?.data?.data?.forEach((p: any) => {
            if (p?.is_free || p?.plan_type === pType) {
                const sortedPerms = p.plan_perms ? [...p.plan_perms].sort((a: any, b: any) => {
                    const orderA = a.permission?.sort_order ?? 100;
                    const orderB = b.permission?.sort_order ?? 100;
                    return orderA - orderB;
                }) : [];
                plansArr.push({ ...p, plan_perms: sortedPerms })
            }
        })
        setPlans(plansArr)
        setPlanType(pType)
        // setSelectedPlan('')
    }

    const handleContinue = () => {
        if (!selectedPlanForSubscribe) {
            return
        }
        const payload = {
            plan_id: selectedPlanForSubscribe,
            success_url: `${window?.location?.origin}${Config?.BASE_URL}${Routes?.PaymentSuccess}`,
            cancel_url: `${window?.location?.origin}${Config?.BASE_URL}${Routes?.Subscription}`
        }
        checkout.makeRequest({ url: ApiConstants?.SubscriptionCheckout, payload })
    }

    const handleFreeTrial = () => {
        if (!selectedPlanForFreeTrial) {
            return
        }
        const payload = {
            plan_id: selectedPlanForFreeTrial,
            success_url: `${window?.location?.origin}${Config?.BASE_URL}${Routes?.PaymentSuccess}`,
            cancel_url: `${window?.location?.origin}${Config?.BASE_URL}${Routes?.Subscription}`
        }
        checkout.makeRequest({ url: ApiConstants?.SubscriptionCheckout, payload })
    }

    useEffect(() => {
        if (checkout?.data?.data?.is_free_plan) {
            const handleNavigate = async () => {
                await profile.makeRequest({ url: ApiConstants?.Profile, type: ApiTypes?.GET }).catch((err: any) => {
                    console.error('Error while subscription------------->', err);
                })
                setTimeout(() => {
                    if (profile?.data?.hh_member) {
                        navigate(Routes?.Profile)
                    } else {
                        navigate(Routes?.AddHousehold, { state: { hide_back: true } })
                    }
                }, 200);
            }
            handleNavigate()
        } else if (checkout?.data?.data?.client_secret) {
            const handleNavigate = async () => {
                const modal: any = $('#stripePaymentModal')
                modal.modal('show');
                setStripeSessionSecret(checkout?.data?.data?.client_secret)
            }
            handleNavigate()
        } else if (checkout?.error) {
            toast.error(checkout?.error?.message)
        }
    }, [checkout?.status, checkout?.error])

    useEffect(() => {
        if (cancelSubscription?.status) {
            toast.success(cancelSubscription?.data?.message)
            getCurrentPlan()
            setTimeout(() => {
                $('.btn-close-cancelSubscription').click();
                setVisibleCancelSubModal(false)
            }, 2000);
        }
    }, [cancelSubscription?.status])

    useEffect(() => {
        if (cancelFreeTrial?.status) {
            setTimeout(() => {
                getCurrentPlan()
                profile.makeRequest({ url: ApiConstants?.Profile, type: ApiTypes?.GET });
            }, 1000);
            toast.success("Free trial cancelled successfully.")
            setVisibleCancelFreeTrialModal(false)
        }
    }, [cancelFreeTrial?.status])

    const handleCancelSubscription = () => {
        cancelSubscription.makeRequest({ url: ApiConstants?.CancelSubscription });
        // toast.promise(
        //     cancelSubscription.makeRequest({ url: ApiConstants?.CancelSubscription }),
        //     {
        //         loading: 'Processing...',
        //         success: (data: any) => data.message,
        //         error: (error: any) => error.message,
        //     }
        // );
    }
    const handleCancelFreeTrial = () => {
        cancelFreeTrial.makeRequest({ url: ApiConstants?.CancelSubscription });
    }

    const handleVerifyPayment = async () => {
        setShowPaymentLoader(true)
        const paymentModal: any = $('#stripePaymentModal');
        paymentModal.modal("hide");
        setStripeSessionSecret(null)
        await subPlans.makeRequest({ url: ApiConstants?.SubscriptionGetPlans })
        getCurrentPlan()
        await profile.makeRequest({ url: ApiConstants?.Profile, type: ApiTypes?.GET })
        setShowPaymentLoader(false)
        setShowContinueButton(true)
        setSelectedPlan('')
    }

    useEffect(() => {
        if (currentPlan?.status) {
            const data = currentPlan?.data?.data;
            if (data) {
                setIsSubscribed(true);
                setShowTrialBox(false);
                if (data?.status === 1) {
                    setSelectedPlan(data?.plan_detail?.uuid);
                    setActivePlanName(data?.plan_detail?.title);
                    setSelectedPlanForSubscribe("");
                    // setSelectedPlanForSubscribe(data?.plan_detail?.uuid)
                } else {
                    setSelectedPlan('');
                }
            } else {
                setIsSubscribed(false);
                setShowTrialBox(true);
                setSelectedPlan('')
            }
        }
    }, [currentPlan?.status]);

    useEffect(() => {
        return () => {
            $('.modal-backdrop').remove();
        }
    }, [])

    console.log("checkedSubTerm: ", checkedSubTerm)
    const validateSubscriptionTerms = () => {
        if (!checkedSubTerm) {
            toast.error('Please agree to the subscription terms.');
            return false;
        }
        return true;
    };

    console.log("plans", plans)

    const getPlanByTitle = (plans: any[], title: string) =>
        plans.find(
            plan => plan.title.toLowerCase() === title.toLowerCase()
        );

    const plusPlan = getPlanByTitle(plans, 'Plus');
    const basicPlan = getPlanByTitle(plans, 'Basic');

    const expiryDate = currentPlan?.data?.data?.plan_expire_date;

    const isExpired = expiryDate && moment(expiryDate).isSameOrBefore(moment(), 'day');

    console.log("isExpired", isExpired);


    const isTrialActive =
        currentPlan?.data?.data?.status === 1 &&
        currentPlan?.data?.data?.is_free === 1 &&
        !isExpired &&
        !profile?.data?.is_free_plan_cancel;

    const canSubscribe = profile?.data?.is_premium || isExpired || isTrialActive || profile?.data?.is_free_plan || isSubscribed;

    const activeSelectedPlanUuid = selectedPlanForSubscribe ||
        (canSubscribe ? selectedPlan : selectedPlanForFreeTrial);

    const handleSelectColumn = (plan: any) => {
        if (canSubscribe) {
            setSelectedPlanForSubscribe(plan.uuid);
            setSelectedPlanName(plan.title);
        } else {
            setSelectedPlanForFreeTrial(plan.uuid);
            setSelectedPlanName(plan.title);
        }
    };

    return (
        <>
            <PageLayout headerName='Subscription' onlyTitle={false}>
                {showPaymentLoader || profile?.loading ? <PaymentLoader /> : ''}
                {/* <TopHeader headerName='Subscription' showMenuOption={true} /> */}
                <div className="subscription-wrapper">
                    <div className="page-padding-x">
                        {/* Trial Box */}
                        {showTrialBox && (
                            <div className="trial-box">
                                <img src={checkTickIcon} alt="Close" />
                                <div className='ms-3'>
                                    <div className="trial-title">Try before you buy</div>
                                    <p>14-day free trial.<span> No credit card required.</span></p>
                                </div>
                            </div>
                        )}

                        <div className="plan-action-buttons">
                            {(profile?.data?.is_premium && currentPlan?.data?.data?.is_free !== 1 && currentPlan?.data?.data?.status === 1) && activePlanName && (
                                <button className="current-plan-btn" disabled>
                                    Current Plan: {activePlanName}
                                </button>
                            )}
                            {isTrialActive &&
                                <button
                                    className="cancel-trial-btn"
                                    onClick={() => {
                                        setVisibleCancelFreeTrialModal(true)
                                    }}
                                >
                                    Cancel Free Trial
                                </button>
                            }

                            {(profile?.data?.is_premium && currentPlan?.data?.data?.is_free !== 1 && currentPlan?.data?.data?.status === 1) &&

                                <button
                                    className="cancel-trial-btn"
                                    onClick={() => {
                                        setVisibleCancelSubModal(true)
                                    }}
                                >
                                    Cancel Subscription
                                </button>
                            }
                        </div>


                        {/* Toggle Plan Type */}
                        {/* <div className="plans-toggle">
                        <span className={`toggle-option ${planType === 'MONTHLY' ? 'active' : ''}`}>Monthly</span>
                        <label className="switch">
                            <input
                                type="checkbox"
                                checked={planType === 'YEARLY'}
                                onChange={(e) => handleChangePlanType(e.target.checked)}
                            />
                            <span className="slider round" />
                        </label>
                        <span className={`toggle-option ${planType === 'YEARLY' ? 'active' : ''}`}>Yearly</span>
                    </div> */}

                        <div className="plans-toggle-radio">
                            <h3 className="all-plans-title">All Plans</h3>

                            <div className="plan-radio-group">

                                {[
                                    {
                                        title: 'Monthly',
                                        value: 'MONTHLY',
                                        isYearly: false,
                                    },
                                    {
                                        title: 'Annual',
                                        value: 'YEARLY',
                                        isYearly: true,
                                    },
                                ].map((plan) => (
                                    <CustomRadioWithTooltip
                                        key={plan.value}
                                        id={plan.value}
                                        name="planType"
                                        value={plan.value}
                                        label={plan.title}
                                        checked={planType === plan.value}
                                        onChange={() => handleChangePlanType(plan.isYearly)}
                                    />
                                ))}
                            </div>
                        </div>


                        <div className="plan-table"
                            style={{
                                gridTemplateColumns: `1.6fr repeat(${plans.length}, 1fr)`
                            }}
                        >
                            {/* Header */}
                            <div className="plan-header">
                                <div className="service-col">Services</div>

                                {plans.map((plan) => {
                                    const isSelected = plan.uuid === activeSelectedPlanUuid;
                                    return (
                                        <div
                                            key={plan.uuid}
                                            className={`plan-col ${isSelected ? 'selected-column' : ''}`}
                                        >
                                            {plan.title}
                                            <img
                                                src={SortIcon}
                                                alt="Sort"
                                                className="sort-icon"
                                            />
                                        </div>
                                    );
                                })}
                            </div>

                            {/* Rows */}
                            {plans.length > 0 && Array.from(
                                new Map(
                                    plans.flatMap(plan =>
                                        plan.plan_perms?.map((p: any) => [
                                            p.permission?.title,
                                            p.permission?.sort_order ?? 100
                                        ]) || []
                                    )
                                ).entries()
                            )
                                .filter(([title]: any) => title)
                                .sort((a: any, b: any) => a[1] - b[1])
                                .map(([title]: any) => title)
                                .map((permissionTitle: any, index) => (
                                    <div
                                        className={`plan-row ${index % 2 === 1 ? 'alt' : ''}`}
                                        key={index}
                                    >
                                        <div className="service-col">{permissionTitle}</div>

                                        {plans.map((plan) => {
                                            const isSelected = plan.uuid === activeSelectedPlanUuid;
                                            return (
                                                <div
                                                    className={`plan-col ${isSelected ? 'selected-column' : ''}`}
                                                    key={plan.uuid}
                                                    onClick={() => handleSelectColumn(plan)}
                                                >
                                                    {plan.plan_perms.some(
                                                        (p: { permission: { title: string; }; }) => p.permission.title === permissionTitle
                                                    ) && <img
                                                            src={tickIcon}
                                                            alt="tick"
                                                            className="tick-icon"
                                                        />}
                                                </div>
                                            );
                                        })}
                                    </div>
                                ))}
                        </div>

                        {profile?.data?.is_free_plan && !profile?.data?.is_free_plan_cancel &&
                            <div className="trial-notification">
                                <div className="trial-notification__header">
                                    <img src={roundBellIcon} alt="" />
                                    <div>
                                        <p className="trial-notification__message">
                                            {isExpired ? (
                                                <>
                                                    Your free trial ended on{" "}
                                                    <span>{moment(expiryDate).format("MMMM D, YYYY")}</span>.
                                                </>
                                            ) : (
                                                <>
                                                    Your 14-day free trial will end on{" "}
                                                    <span>{moment(expiryDate).format("MMM DD, YYYY")}</span>.
                                                </>
                                            )}
                                        </p>
                                        <p className="trial-notification__subtext">
                                            To keep using Justivide, choose a plan below.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        }


                        {canSubscribe &&
                            <div className="subscription-plans-container">
                                <div className="plans-wrapper">
                                    {plans.map((plan) => (
                                        <div
                                            key={plan.uuid}
                                            className={`plan-card ${plan.uuid == selectedPlanForSubscribe ? 'plan-card--seleted' : 'plan-card--normal'}`}
                                        >
                                            <h2 className="plan-card__title">
                                                {plan.title} Plan
                                            </h2>

                                            <p className="plan-card__price">
                                                ${plan.price}/{planType === 'MONTHLY' ? 'monthly' : 'year'}
                                            </p>

                                            <button
                                                onClick={() => {
                                                    setSelectedPlanForSubscribe(plan.uuid)
                                                    setSelectedPlanName(plan.title)
                                                }}
                                                className="plan-card__button"
                                            >
                                                Select
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        }


                        {canSubscribe && selectedPlanForSubscribe &&
                            <div className="plan-note-box">
                                <div className="note-title">Subscription Terms</div>
                                {selectedPlanName == "Plus" ?
                                    <ul>
                                        <li>
                                            By subscribing, you agree that you will be charged <span>${plusPlan?.price}</span> for your <span>Plus</span> plan.
                                        </li>
                                        <li>
                                            It will begin today and automatically renew <span>{planType === 'MONTHLY' ? 'monthly' : 'annually'}</span> at the then-current price (currently <span>${plusPlan?.price}</span>) unless you cancel.
                                        </li>
                                        <li>
                                            However, if you are upgrading from a monthly plan to an annual plan, or from an annual plan to a monthly plan, your new plan will begin after your next renewal date.
                                        </li>
                                        <li>
                                            Taxes may apply; pricing subject to change.
                                        </li>
                                        <li>
                                            Cancel in the “My Subscription” section of your account prior to any renewal to avoid future charges. No refunds unless required by law.
                                        </li>
                                    </ul>
                                    :
                                    <ul>
                                        <li>
                                            By subscribing, you agree that you will be charged <span>${basicPlan?.price}</span> for your <span>Basic</span> plan.
                                        </li>
                                        <li>
                                            It will begin today and automatically renew <span>{planType === 'MONTHLY' ? 'monthly' : 'annually'}</span> at the then-current price (currently <span>${basicPlan?.price}</span>) unless you cancel.
                                        </li>
                                        <li>
                                            However, if you are upgrading from a monthly plan to an annual plan, or from an annual plan to a monthly plan, your new plan will begin after your next renewal date.
                                        </li>
                                        <li>
                                            Taxes may apply; pricing subject to change.
                                        </li>
                                        <li>
                                            Cancel in the “My Subscription” section of your account prior to any renewal to avoid future charges. No refunds unless required by law.
                                        </li>
                                    </ul>
                                }

                                <Checkbox
                                    checked={checkedSubTerm}
                                    onChange={(e) => {
                                        setCheckedSubTerm(e.target.checked)
                                    }}
                                    labelText=""
                                    name='subscription_term'
                                    links={[
                                        { text: 'I agree to these subscription terms', isLink: false }
                                    ]}
                                />
                            </div>
                        }



                        {showTrialBox && (
                            <div className="active-plan-card">
                                <div className="plan-title">
                                    {(plans.find(p => p.uuid === selectedPlanForFreeTrial)?.title || 'Plus')} Plan
                                </div>

                                <div className="trial-pill">
                                    14-day free trial
                                </div>
                            </div>
                        )}


                        {/* Plan Note Box */}
                        {showTrialBox &&
                            <div className="plan-note-box">
                                <div className="note-title">Free Trial Terms</div>

                                <ul>
                                    <li>
                                        After the 14-day free trial, you and your household members will lose access to the app's features unless you subscribe.
                                    </li>
                                    <li>
                                        You can cancel your free trial at any time by going to My Account,
                                        selecting the My Subscription link, and clicking Cancel Free Trial.
                                    </li>
                                </ul>
                            </div>
                        }



                        {/* Action Buttons */}
                        <div className="action-buttons pb-5">
                            {isSubscribed ?
                                <>
                                    {(profile?.data?.is_premium && currentPlan?.data?.data?.is_free !== 1 && currentPlan?.data?.data?.status === 1) ? (
                                        <div className="action-buttons-wrapper">
                                            <button className="com-btn com-btn-outline" onClick={() => { setVisibleCancelSubModal(true) }}>
                                                Cancel Subscription
                                            </button>
                                            {selectedPlan !== selectedPlanForSubscribe &&
                                                <Button
                                                    className="com-btn"
                                                    loading={checkout?.loading}
                                                    disabled={!selectedPlanForSubscribe}
                                                    onClick={() => {
                                                        if (!validateSubscriptionTerms()) return;
                                                        handleContinue();
                                                    }}
                                                >
                                                    Change Plan
                                                </Button>
                                            }
                                        </div>
                                    ) : (
                                        <>
                                            {isTrialActive ?
                                                <div className="action-buttons-wrapper">
                                                    <button className="com-btn com-btn-outline"
                                                        onClick={() => {
                                                            setVisibleCancelFreeTrialModal(true)
                                                        }}

                                                    >
                                                        Cancel Free Trial
                                                    </button>
                                                    <Button
                                                        className="com-btn"
                                                        loading={checkout?.loading}
                                                        disabled={!selectedPlanForSubscribe}
                                                        onClick={() => {
                                                            if (!validateSubscriptionTerms()) return;
                                                            handleContinue();
                                                        }}
                                                    >
                                                        Subscribe
                                                    </Button>
                                                </div>
                                                :
                                                <div className="action-buttons-wrapper">
                                                    <Button
                                                        className="com-btn full-width"
                                                        loading={checkout?.loading}
                                                        disabled={!selectedPlanForSubscribe}
                                                        onClick={() => {
                                                            if (!validateSubscriptionTerms()) return;
                                                            handleContinue();
                                                        }}
                                                    >
                                                        Subscribe
                                                    </Button>
                                                </div>
                                            }
                                        </>

                                    )}
                                </>
                                :
                                <div className="action-buttons-wrapper">
                                    <Button
                                        className="com-btn full-width"
                                        loading={checkout?.loading}
                                        disabled={!selectedPlanForFreeTrial}
                                        onClick={handleFreeTrial}
                                    >
                                        Start Free Trial
                                    </Button>
                                </div>
                            }
                        </div>
                        <div className="help-section">
                            <h2 className="help-title">Need help?</h2>
                            <p className="help-text">
                                Email us at <a href="mailto:support@justivide.com">support@justivide.com</a> or use the <Link to={Routes?.ContactUs}>Contact Us</Link> link in My Account.
                            </p>
                        </div>
                    </div>
                </div>

                {/*==== Cancel Subscription Modal Box Start ====*/}
                <div className="modal fade inner-modal com-modal" id="cancelSubscription" tabIndex={-1} aria-labelledby="cancelSubscriptionLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="modal-body pt-4 pb-0">
                                <p className='com-modal-para mb-2 mt-3'>Are you sure you want to cancel <br /> your subscription?</p>
                            </div>
                            <div className='modal-footer border-0 mt-3 justify-content-center'>
                                <button type='button' className='com-btn com-btn-gray btn-close-cancelSubscription' id='btn-close-modal' data-bs-dismiss="modal" >Cancel</button>
                                <Button type='button' className='com-btn' onClick={handleCancelSubscription} loading={cancelSubscription?.loading}>Confirm</Button>
                            </div>
                        </div>
                    </div>
                </div>
                {/*==== Cancel Subscription Modal Box End ====*/}

                {visibleCancelFreeTrialModal &&
                    <CustomModal
                        title={`Are you sure you would like to cancel your free trial? You and your household members will lose access to the app's features, including any data entered by you or other household members, upon cancellation, even if you have not completed your 14-day free trial.`}
                        onConfirm={handleCancelFreeTrial}
                        loading={cancelFreeTrial.loading}
                        buttonTxt2='Return'
                        toggleModal={() => {
                            setVisibleCancelFreeTrialModal(false)
                        }}
                    />
                }

                {visibleCancelSubModal &&
                    <CustomModal
                        title={`Are you sure you would like to cancel your subscription? You and your household members will still be able to access your subscription until the end of the current billing cycle, at which time you and your household members will lose access to the app's features, including any data entered by you or other household members. You will not be entitled to a refund unless required by law.`}
                        onConfirm={handleCancelSubscription}
                        buttonTxt2='Return'
                        loading={cancelSubscription?.loading}
                        buttonTxt='Cancel Subscription'
                        toggleModal={() => {
                            setVisibleCancelSubModal(false)
                        }}
                    />
                }
                {/*==== STRIPE Modal Box Start ====*/}
                <div className="modal fade inner-modal com-modal" id="stripePaymentModal" tabIndex={-1} aria-labelledby="welcomeLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="modal-header border-0">
                                <button type="button" onClick={handleVerifyPayment} className="btn-close"><i className='icon-close-circle'></i></button>
                            </div>
                            <div className="modal-body pt-4 pb-0">
                                {stripeSessionSecret ? (
                                    <CheckoutForm clientSecret={stripeSessionSecret} />
                                ) : ""}
                            </div>
                        </div>
                    </div>
                </div>
                {/*==== STRIPE Modal Box End ====*/}
            </PageLayout>
        </>
    )
}

export default Subscription